import React from 'react';

import PropTypes from 'prop-types';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';

import { SafelyRenderHtml } from '@src/services';

const startsWithColDiv = (html) => {
    const firstElement = html.trim().match(/^<div\b[^>]*>/i);

    if (!firstElement) return false;

    const classAttribute = firstElement[0].match(/\bclass\s*=\s*(?:"([^"]*)"|'([^']*)'|([^\s>]+))/i);
    const classNames = classAttribute && (classAttribute[1] || classAttribute[2] || classAttribute[3]);

    return Boolean(
        classNames
        && classNames.split(/\s+/).some((className) => /^col(?:-|$)/.test(className)),
    );
};

const DiscountsSection = ({ data, id }) => {
    const {
        heading,
        body_html: bodyHtml,
        items,
        disclaimer,
    } = data || {};

    const hasItems = Array.isArray(items) && items.length > 0;
    const hasCardLayout = hasItems
        && items.some((item) => typeof item === 'object' && Boolean(item?.description && item.description.trim().length > 0));

    return (
        <section id={id || 'discounts'} className="col-12 p-0">
            <div className="container-fluid p-0 bg-color">
                {
                    heading
                    && (
                        <Row className="features-module section-header-container">
                            <Col>
                                <h2>{SafelyRenderHtml(heading)}</h2>
                            </Col>
                        </Row>
                    )
                }
                {
                    hasItems ? (
                        hasCardLayout ? (
                            <Row className="customer-discounts-row main-container-row">
                                {items.map((item, index) => {
                                    const title = typeof item === 'string' ? item : (item?.name || item?.title);
                                    const description = typeof item === 'object' ? item?.description : '';
                                    const colProps = items.length === 1 ? { xs: 12, md: 12, lg: 12 } : { xs: 12, md: 6, lg: 6 };

                                    return (
                                        <Col key={`discount-block-${title || index}`} {...colProps}>
                                            <div className="panel panel-default">
                                                <div className="panel-body">
                                                    {title && <h4>{SafelyRenderHtml(title)}</h4>}
                                                    {description && <p>{SafelyRenderHtml(description)}</p>}
                                                </div>
                                            </div>
                                        </Col>
                                    );
                                })}
                            </Row>
                        ) : (
                            <Row className="features-c main-container-row pb-5">
                                <Col>
                                    <ul className="discount-list">
                                        {items.map((item, index) => {
                                            const nameText = typeof item === 'string' ? item : (item?.name || item?.title);
                                            return (
                                                <li key={`discount-item-${nameText || index}`}>
                                                    {SafelyRenderHtml(nameText)}
                                                </li>
                                            );
                                        })}
                                    </ul>
                                </Col>
                            </Row>
                        )
                    ) : (
                        bodyHtml && (
                            <Row className="customer-discounts-row main-container-row">
                                {
                                    startsWithColDiv(bodyHtml)
                                        ? SafelyRenderHtml(bodyHtml)
                                        : <Col>{SafelyRenderHtml(bodyHtml)}</Col>
                                }
                            </Row>
                        )
                    )
                }
            </div>
            {
                disclaimer
                && (
                    <div className="container-fluid mt-3">
                        <Row>
                            <Col className="text-center">
                                <i>{SafelyRenderHtml(disclaimer)}</i>
                            </Col>
                        </Row>
                    </div>
                )
            }
        </section>
    );
};

DiscountsSection.propTypes = {
    data: PropTypes.shape({
        heading: PropTypes.string,
        body_html: PropTypes.string,
        items: PropTypes.arrayOf(PropTypes.oneOfType([
            PropTypes.string,
            PropTypes.shape({
                name: PropTypes.string,
                title: PropTypes.string,
                description: PropTypes.string,
            }),
        ])),
        disclaimer: PropTypes.string,
    }),
    id: PropTypes.string,
};

export default DiscountsSection;
